/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import ReportOffIcon from '@mui/icons-material/ReportOff';
import { Box, Typography, Link } from '@mui/material';
import { getBaseUrl } from '../../utilities/urlHelper';

const IntrinsicContainer = styled('div')`
  position: relative;
  height: 0;
  overflow: hidden;
  background-color: #ececec;
  padding-bottom: 56.25%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const LoadingContainer = styled('div')`
  position: absolute;
  zIndex: 9;
  width: 100%;
  height: 100%;
  backgroundColor: rgb(255 255 255 / 80%);
`;

type Props = {
  frameSrc?: string;
  hideAnnotation?: boolean;
}

const DLFrame: React.FC<Props> = ({
  frameSrc,
  hideAnnotation = true,
}: Props) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    if (frameSrc) {
      setLoader(true);
    }
  }, [frameSrc, dispatch]);

  return (
    <IntrinsicContainer
      style={frameSrc ? { boxShadow: 'inset -1px 1px 1px #ececec' } : undefined}
    >
      {
        !frameSrc && (
          <LoadingContainer>
            <Box
              sx={{
                position: 'absolute',
                bottom: '50%',
                right: '50%',
              }}
            >
              <ReportOffIcon
                sx={{
                  width: 50,
                  height: 50,
                  position: 'absolute',
                  bottom: '10px',
                  right: '-25px',
                }}
                color="disabled"
              />
              <Typography
                sx={{
                  position: 'absolute',
                  right: '-120px',
                  width: 200,
                }}
                variant="body2"
                color="textSecondary"
              >
                No Digital Case to Show
              </Typography>
            </Box>
          </LoadingContainer>
        )
      }
      {
        loader && (
          <LoadingContainer>
            <CircularProgress
              sx={{
                zIndex: 10,
                position: 'absolute',
                bottom: '50%',
                right: '50%',
              }}
            />
          </LoadingContainer>
        )
      }
      {
        frameSrc && (
          <iframe
            onLoad={() => { setLoader(false); }}
            src={`${frameSrc}?embeddedmode=true&skipacceptapplicationpolicy=true&hideallannotations=${hideAnnotation}&disableswitchlabel=true`}
            title="digitallab"
            allowFullScreen
            frameBorder={0}
            sandbox="allow-scripts allow-same-origin"
            scrolling="no"
          />
        )
      }
    </IntrinsicContainer>
  );
};

export default DLFrame;
